<div class="litmus-header-container">
    <div [class.required]="isRequired"  [class.litmus-header]="type != 'sub-header'"  [class.litmus-sub-header]="type == 'sub-header'">{{text}}</div>
</div>
